module.exports = __webpack_public_path__ + "img/section_loans.7f34c8ee.png";